
// Require
var BaseModal = require('./base-modal');

// Class reference
var successClass = 'positive';
var failureClass = 'negative';


//
// Error Modal
//

module.exports = function ErrorModal ($host, config) {

  // Extend Base
  var base = BaseModal($host, config);

  // DOM
  var $title  = $('[data-modal-output-title]',      $host);
  var $text   = $('[data-modal-output-error-text]', $host);
  var $href   = $('[data-modal-output-href]',       $host);
  var $action = $('[data-modal-output-action]',     $host);

  // Functions
  function populate (data) {
    $title.text(data.title ? data.title : "Error");
    $text.html (data.text  ? data.text  : "");

    if (data.action) {
      $href.show().attr('href', data.action.href ? data.action.href : "");
      $action.text(data.action.text ? data.action.text : "Do Something");
    } else {
      $href.hide();
    }
  }

  // Init
  return {
    invoke: function (data) {
      base.reveal();
      populate(data);
    }
  };

};

